import APIV5 from '~/models/api';
import templateModalInfo from '../modal/modal-info.html';
import ModalInfoController from '../modal/modal-info.controller';

export default class OoAdminAttributeEditorController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor($scope, $uibModal) {
		this.$scope = $scope;
		this.$uibModal = $uibModal;

		/** @type {import('~/scripts/services/model/attribut').default[]} */
		this.attribut = [];

		/** @type {boolean} */
		this.disabled = true;

		/** @type {?import('angular').IFormController} */
		this.form = null;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {?import('~/scripts/services/model/node').default} */
		this.node = null;

		/** @type {import('~/scripts/services/model/attribut').default | undefined} */
		this.tmp = undefined;

		/** @type {{type_kid: ?import('@knitiv/api-client-javascript').KNode, type_name: string}[]} */
		this.typeList = [];
	}

	/**
	 * @param {any} attribut
	 */
	add(attribut) {
		if (!this.disabled && attribut) {
			this.node?.addAttribute(attribut);
			this.form?.$setDirty();
			this.tmp = undefined;
		}
	}

	/**
	 * @param {any} attribut
	 */
	del(attribut) {
		if (attribut) {
			this.node?.delAttribute(attribut.name);
			this.form?.$setDirty();
		}
	}

	/**
	 * @param {string} type_kid
	 * @returns {string}
	 */
	getTypeName(type_kid) {
		const type = this.typeList?.find(t => t.type_kid === type_kid);
		return type?.type_name ?? '';
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	info(kid) {
		this.$uibModal.open({
			template: templateModalInfo,
			controller: ModalInfoController,
			controllerAs: '$ctrl',
			resolve:      {
				kid: () => kid,
			},
		});
	}

	$onInit() {
		(async () => {
			const data = await APIV5.instance.attributTypeList({ id: 'oo-admin-attribute-editor.init' });
			this.typeList = Object.values(data.result);
		})();
		this.$scope.$watch('$ctrl.tmp', () => {
			// this.ngModelCtrl?.$validate();
			this.ngModelCtrl?.$setValidity('required', !this.tmp?.ref_type && !this.tmp?.name && !this.tmp?.value);
		});
		// if (this.ngModelCtrl) {
		// 	this.ngModelCtrl.$validators.required = () => {
		// 		let valid = true;
		// 		if (this.tmp?.ref_type || this.tmp?.name || this.tmp?.value) {
		// 			valid = false;
		// 		}
		// 		console.log('this.tmp', this.tmp, valid);
		// 		return valid;
		// 	};
		// }
	}
}
